import { Table, Input, Space, Button, Checkbox } from "antd";
import React, { useState, useRef, useEffect } from "react";
import {
  UploadOutlined,
  PrinterOutlined,
  DeleteOutlined,
  EditOutlined,
  BarsOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { IntToBetrag } from "../Helper/ZahlenFormat";
import TextArea from "antd/es/input/TextArea";
import { LayoutData } from "../Structur/Aconlayout";

export const AconKundenListe = ({
  title,
  dataSource,
  loading,
  handleOnDetailClick,
  handleOnEMailsClick,
}) => {
  const { mainContainerHeight } = LayoutData();

  const getColumns = () => {
    const columns = [
      {
        title: "EMails",
        key: "action1",
        dataIndex: "recnr",
        width: 50,
        render: (recnr, record) => (
          <>
            <span
              onClick={() => {
              handleOnEMailsClick(record);
              }}
              style={{ cursor: "pointer" }}
            >
              <BarsOutlined style={{ fontSize: 20 }} />
            </span>
          </>
        ),
      },
      {
        title: "Detail",
        key: "aktion2",
        width: 50,
        dataIndex: "recnr",
        render: (recnr, record) => (
          <span
            onClick={() => {
                handleOnDetailClick(record);
            }}
            style={{ cursor: "pointer" }}
          >
            <EditOutlined style={{ fontSize: 20 }} />
          </span>
        ),
      },
      {
        title: "Suchbegriff",
        dataIndex: "suchbegriff",
        width: 200,
        minWidth: 120,
        align: "left",
        render: (text) => <b>{text}</b>,
      },
      {
        title: "Name",
        dataIndex: "name",
        fixed: "left",
        width: 200,
        minWidth: 120, // Mindestbreite der Spalte
        //ellipsis: true,
        render: (text, record) => <>{text}</>,
      },
      {
        title: "Email",
        dataIndex: "email",
        fixed: "left",
        width: 200,
        minWidth: 120, // Mindestbreite der Spalte
        //ellipsis: true,
        render: (text, record) => <>{text}</>,
      },
    ];

    return columns;
  };

  const cancel = () => {};
  return (
    <>
      {/*
      Liste der Konten hier  {aktjahr}, {aktklasse} - Search: {searchText}
        */}

      <Table
        title={title}
        rowSelection={false}
        size="small"
        columns={getColumns()} 
        dataSource={dataSource}
        bordered
        loading={loading}
        fixed
        pagination={{
          // pageSize: 50,
          onChange: cancel,
        }}
        scroll={{
          y: mainContainerHeight > 380 ? mainContainerHeight - 180 : 120,
        }}
      />
    </>
  );
};
